// Smooth-scroll helper that routes through the active Lenis instance when present.
export const scrollToTarget = (target) => {
  const lenis = typeof window !== "undefined" ? window.__lenis : null;
  if (lenis) {
    lenis.scrollTo(target, { offset: -10, duration: 1.2 });
    return;
  }
  if (target === 0 || target === "top") {
    window.scrollTo({ top: 0, behavior: "smooth" });
    return;
  }
  const el = typeof target === "string" ? document.querySelector(target) : target;
  el?.scrollIntoView({ behavior: "smooth" });
};
